import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import { paymentsService } from 'src/services/payments.service'
import { IUpgradeSubscriptionDto } from 'src/types'

const useUpgradeSubscription = () => {
  const { accountId } = useParams()
  return useMutation(async (dto: Omit<IUpgradeSubscriptionDto, 'accountId'>) =>
    paymentsService.upgradeSubscription({ ...dto, accountId: accountId! }),
  )
}

export { useUpgradeSubscription }
